<h2 mat-dialog-title>Save new material revision</h2>
<mat-dialog-content>
    @if ($exportWarnings().length > 0) {
        <section class="cm-export-warnings">
            <div class="cm-export-warnings-header">
                <i class="fa-solid fa-triangle-exclamation"></i>
                <div>
                    <div class="cm-export-warnings-heading">The maps exporter cannot read this material</div>
                    <div class="cm-export-warnings-note">Saving is unaffected — this only concerns exports and publishing.</div>
                </div>
            </div>
            <ul class="cm-export-warnings-list">
                @for (warning of $exportWarnings(); track $index) {
                    <li>
                        @if (warning.slot) {
                            <span class="cm-export-warnings-slot">{{ warning.slot }}</span>
                        }
                        <span class="cm-export-warnings-message">{{ warning.message }}</span>
                    </li>
                }
            </ul>
            <div class="cm-export-warnings-hint">{{ exportableChainHint }}</div>
        </section>
    }
    <form id="matRevisionForm" (submit)="confirmAction()">
        <mat-form-field>
            <input
                [disabled]="!$can().update.materialRevision(null, 'material')"
                [ngModel]="$materialInfo()?.legacyId"
                (ngModelChange)="materialChanged(undefined, $event)"
                matInput
                type="number"
                placeholder="Material ID"
                name="materialId"
            />
        </mat-form-field>
        <mat-form-field appearance="fill">
            <input [ngModel]="$materialInfo()?.name" matInput type="string" placeholder="Material name" name="materialName" [disabled]="true" />
        </mat-form-field>
        <mat-form-field appearance="fill">
            <input [ngModel]="$materialInfo()?.range" matInput type="string" placeholder="Range" name="rangeName" [disabled]="true" />
        </mat-form-field>
        <mat-form-field appearance="fill">
            <input [ngModel]="$materialInfo()?.customer" matInput type="string" placeholder="Customer" name="customerName" [disabled]="true" />
        </mat-form-field>
        <mat-form-field appearance="fill">
            <textarea
                [ngModel]="$result().comment"
                (ngModelChange)="$result.set({...$result(), comment: $event})"
                matInput
                rows="3"
                placeholder="Comment"
                name="revisionComment"
            >
            </textarea>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="cancelAction()">Cancel</button>
    <button mat-button form="matRevisionForm" [disabled]="false">Save</button>
</mat-dialog-actions>
